import lightbox from 'lightbox2/dist/js/lightbox-plus-jquery';


export function initLightbox() {
    console.log("Lightbox")
    lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true,
        'showImageNumberLabel': false,
    })
}

